import Vue from 'vue'
import loadMore from '@/directives/loadMore'
import title from '@/directives/title'
import clickoutside from '@/directives/clickoutside'

// el-table 触底加载
Vue.directive('load-more', loadMore)

// 模拟浏览器title效果
Vue.directive('title', title)

// 点击元素外侧执行绑定事件
Vue.directive('clickoutside', clickoutside)
